/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserControllerChangeUserPlanRequest
 */
export interface UserControllerChangeUserPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof UserControllerChangeUserPlanRequest
     */
    subscriptionPlanId: string;
}

/**
 * Check if a given object implements the UserControllerChangeUserPlanRequest interface.
 */
export function instanceOfUserControllerChangeUserPlanRequest(value: object): value is UserControllerChangeUserPlanRequest {
    if (!('subscriptionPlanId' in value) || value['subscriptionPlanId'] === undefined) return false;
    return true;
}

export function UserControllerChangeUserPlanRequestFromJSON(json: any): UserControllerChangeUserPlanRequest {
    return UserControllerChangeUserPlanRequestFromJSONTyped(json, false);
}

export function UserControllerChangeUserPlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserControllerChangeUserPlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionPlanId': json['subscriptionPlanId'],
    };
}

export function UserControllerChangeUserPlanRequestToJSON(json: any): UserControllerChangeUserPlanRequest {
    return UserControllerChangeUserPlanRequestToJSONTyped(json, false);
}

export function UserControllerChangeUserPlanRequestToJSONTyped(value?: UserControllerChangeUserPlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionPlanId': value['subscriptionPlanId'],
    };
}

